import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

export default function RoomBookingDrawer() {

	const history = useHistory();	
	
  const floors = [
    { name: "Ground Floor", desks: 48, occupancy: 0.42 },
    { name: "Level 1", desks: 64, occupancy: 0.58 },
    { name: "Level 2", desks: 72, occupancy: 0.71 },
    { name: "Level 3", desks: 60, occupancy: 0.36 },
    { name: "Level 4", desks: 54, occupancy: 0.81 }
  ];

  const panelContainer = {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  };

  const floorRow = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 16px",
    borderRadius: "12px",
    background: "#ffffff",
    border: "1px solid #eee",
    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  };

  const floorInfo = {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  };

  const floorName = {
    fontSize: "14px",
    fontWeight: 600,
    color: "#111"
  };

  const floorDesks = {
    fontSize: "12px",
    color: "#666"
  };

  const occupancyContainer = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: "140px"
  };

  const barBackground = {
    width: "80px",
    height: "8px",
    background: "#f0f0f0",
    borderRadius: "8px",
    overflow: "hidden"
  };

  const getBarFill = (pct) => ({
    height: "100%",
    width: `${Math.round(pct * 100)}%`,
    background: "#f4c400", // Diamond yellow
    borderRadius: "8px",
    transition: "width 0.3s ease"
  });

  const percentLabel = {
    fontSize: "12px",
    fontWeight: 600,
    color: "#333",
    width: "36px",
    textAlign: "right"
  };
  
  const goFloor = function () {
     history.push("/roombooking/floor");
   };

  return (
    <div style={panelContainer}>
      {floors.map((floor, index) => (
        <div
          key={index}
          style={floorRow}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#f4c400";
            e.currentTarget.style.color = "#000";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#ffffff";
            e.currentTarget.style.color = "#111";
          }}
		  onClick={goFloor}
        >
          <div style={floorInfo}>
            <div style={floorName}>{floor.name}</div>
            <div style={floorDesks}>{floor.desks} desks</div>
          </div>

          <div style={occupancyContainer}>
            <div style={barBackground}>
              <div style={getBarFill(floor.occupancy)} />
            </div>
            <div style={percentLabel}>{Math.round(floor.occupancy * 100)}%</div>
            <FontAwesomeIcon icon={faChevronRight} style={{ color: "#000" }} />
          </div>
        </div>
      ))}
    </div>
  );
}
